export const PricingTable = [
    [10000, 0.15],
    [10000, 0.14],
    [20000, 0.13],
    [40000, 0.12],
    [80000, 0.11],
    [160000, 0.095],
    [320000, 0.094],
    [160000, 0.090],
    [480000, 0.086],
    [1280000, 0.078],
    [940000, 0.07],
    [1620000, 0.06],
    [2880000, 0.05],
    [2240000, 0.035],
    [10240000, 0.017],
]

// export const PricingSetting = {
//     mediumBasic: 800,
//     mediumAddiction: 0.2,
    
//     highBasic: 4000,
//     highFreeQuota: 25000
// }

export const PricingSetting = {
    low: {
        basicPrice: 0,
        freeQuota: 500,
    },
    medium: {
        basicPrice: 800,
        addictionPrice: 0.2,
        freeQuota: 4000
    },
    high: {
        basicPrice: 4000,
        freeQuota: 25000,
        addictionTop: 0.01,
        tiers: 14
    }

}


// WEBPACK FOOTER //
// ./src/components/pricingTable.js